<form [formGroup]="fG">
  <ejs-switch [formControlName]="fCN" [onLabel]="onLabel | translate" [offLabel]="offLabel | translate"></ejs-switch>
  <ng-content/>
</form>
